import axios from "axios";
import { startRequest, endRequest, setError } from "../ui/globalUI";

const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL || (process.env.NODE_ENV === 'production' ? '/' : 'http://localhost:4000'),
  headers: {
    "Content-Type": "application/json",
  },
});

instance.interceptors.request.use(
  function (config) {
    // show global loader — skipped for `silent` background requests
    if (!config.silent) startRequest();
    if (config.url.match("login")) {
      return config;
    } else {
      config.headers["Authorization"] = `Bearer ${localStorage.getItem(
        "token"
      )}`;
      return config;
    }
  },
  function (error) {
    endRequest();
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  function (response) {
    if (!response.config?.silent) endRequest();
    return response.data;
  },
  async function (error) {
    const silent = error?.config?.silent;
    if (!silent) endRequest();
    if (silent) {
      // Background request: no loader, no error popup — caller handles it.
    } else if (error && error.response && error.response.status === 401) {
      localStorage.clear();
      window.location.reload();
    } else {
      // Try to extract a meaningful message from response body
      try {
        let body = error && error.response ? error.response.data : null;
        let message = "";
        if (body) {
          if (typeof Blob !== "undefined" && body instanceof Blob) {
            const text = await body.text();
            try {
              const json = JSON.parse(text);
              message = json.message || text;
            } catch (_) {
              message = text;
            }
          } else if (typeof body === "object") {
            message = body.message || JSON.stringify(body);
          } else if (typeof body === "string") {
            message = body;
          }
        }
        if (!message) {
          message = error?.message || "Đã xảy ra lỗi";
        }
        setError(message);
      } catch (_) {
        setError(error?.message || "Đã xảy ra lỗi");
      }
    }
    return Promise.reject(error && error.response ? error.response.data : error);
  }
);

export default instance;
